module.exports = __webpack_public_path__ + "static/media/400158_01.eccf8525.png";